export default __webpack_public_path__ + "static/media/Himanshi Gaur.aa67d566.JPG";